import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Image, ListGroup, ListGroupItem } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import Location from '../../images/location.png';
import Search from '../../images/search.png';
import Industries from '../../images/tie.png';
import { Building, Cog } from '../../components/Icons';
import InfoIcon from '../../components/InfoIcon';
import { getSetting } from '../../actions/settings/settingsCreators';
import User from '../../images/user.png';

class GlobalMenu extends Component {
  componentDidMount() {
    const { getSetting } = this.props;
    getSetting('globalIndustriesInfoHoverText');
    getSetting('globalCatchmentSetsInfoHoverText');
    getSetting('globalBookingsInfoHoverText');
    getSetting('globalInsightSetsInfoHoverText');
    getSetting('globalCustomerInfoHoverText');
    getSetting('globalReferenceLayersInfoHoverText');
  }

  render() {
    const { settings } = this.props;
    return (
      <div className="global-menu">
        <h2>Global</h2>
        <div className="module">
          {this.props.image && (
            <Image src={this.props.image} alt="" responsive />
          )}
          <div className="no-select" />
          <ListGroup>
            <ul>
              <li className="industries">
                <LinkContainer to="/industries" onClick={this.props.closeMenu}>
                  <ListGroupItem className="no-underline">
                    <Image src={Industries} className="dashboard-icon" alt="" />{' '}
                    Industries
                    {settings && settings.globalIndustriesInfoHoverText && (
                      <InfoIcon>
                        {settings.globalIndustriesInfoHoverText.value}
                      </InfoIcon>
                    )}
                  </ListGroupItem>
                </LinkContainer>
              </li>
              <li className="reference-layers">
                <LinkContainer
                  to="/reference-layers"
                  onClick={this.props.closeMenu}
                >
                  <ListGroupItem className="no-underline">
                    <Image src={Location} className="dashboard-icon" alt="" />{' '}
                    Reference Layers
                    {settings &&
                      settings.globalReferenceLayersInfoHoverText && (
                        <InfoIcon>
                          {settings.globalReferenceLayersInfoHoverText.value}
                        </InfoIcon>
                      )}
                  </ListGroupItem>
                </LinkContainer>
              </li>

              <li className="bookings">
                <LinkContainer
                  to="/global/0/bookings"
                  onClick={this.props.closeMenu}
                >
                  <ListGroupItem className="no-underline">
                    <Image src={Location} className="dashboard-icon" alt="" />{' '}
                    Bookings
                    {settings && settings.globalBookingsInfoHoverText && (
                      <InfoIcon>
                        {settings.globalBookingsInfoHoverText.value}
                      </InfoIcon>
                    )}
                  </ListGroupItem>
                </LinkContainer>
              </li>

              <li className="campaigns">
                <LinkContainer
                  to="/global/0/campaigns"
                  onClick={this.props.closeMenu}
                >
                  <ListGroupItem className="no-underline">
                    <Image src={Location} className="dashboard-icon" alt="" />{' '}
                    Campaigns
                    {settings && settings.globalCampaignsInfoHoverText && (
                      <InfoIcon>
                        {settings.globalCampaignsInfoHoverText.value}
                      </InfoIcon>
                    )}
                  </ListGroupItem>
                </LinkContainer>
              </li>

              <li className="shape-sets">
                <LinkContainer
                  to="/global/0/catchment-sets"
                  onClick={this.props.closeMenu}
                >
                  <ListGroupItem className="no-underline">
                    <Image src={Location} className="dashboard-icon" alt="" />{' '}
                    Catchment Sets
                    {settings && settings.globalCatchmentSetsInfoHoverText && (
                      <InfoIcon>
                        {settings.globalCatchmentSetsInfoHoverText.value}
                      </InfoIcon>
                    )}
                  </ListGroupItem>
                </LinkContainer>
              </li>

              <li className="insight-sets">
                <LinkContainer
                  to="/insight-sets"
                  onClick={this.props.closeMenu}
                >
                  <ListGroupItem className="no-underline">
                    <Image src={Search} className="dashboard-icon" alt="" />{' '}
                    Insight Sets
                    {settings && settings.globalInsightSetsInfoHoverText && (
                      <InfoIcon>
                        {settings.globalInsightSetsInfoHoverText.value}
                      </InfoIcon>
                    )}
                  </ListGroupItem>
                </LinkContainer>
              </li>

              <li className="customers">
                <LinkContainer to="/customers" onClick={this.props.closeMenu}>
                  <ListGroupItem className="no-underline">
                    <Building height="32px" width="32px" /> Customers
                    {settings && settings.globalCustomerInfoHoverText && (
                      <InfoIcon>
                        {/* Hover text value is directly injected as HTML as we needed to display an unordered list in the tooltip, retrieved via the API */}
                        <div
                          dangerouslySetInnerHTML={{
                            __html: settings.globalCustomerInfoHoverText.value
                          }}
                        />
                      </InfoIcon>
                    )}
                  </ListGroupItem>
                </LinkContainer>
              </li>

              <li className="users">
                <LinkContainer
                  to="/global/0/users"
                  onClick={this.props.closeMenu}
                >
                  <ListGroupItem className="no-underline">
                    {/* TODO: Change these to settings specific */}
                    <Image src={User} className="dashboard-icon" alt="" /> Users
                  </ListGroupItem>
                </LinkContainer>
              </li>

              <li className="settings">
                <LinkContainer to="/settings" onClick={this.props.closeMenu}>
                  <ListGroupItem className="no-underline">
                    {/* TODO: Change these to settings specific */}
                    <Cog height="32px" width="32px" color="#db1929" /> Global
                    Settings
                    {settings && settings.globalSettingsInfoHoverText && (
                      <InfoIcon>
                        {settings.globalSettingsInfoHoverText.value}
                      </InfoIcon>
                    )}
                  </ListGroupItem>
                </LinkContainer>
              </li>
            </ul>
          </ListGroup>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    settings: state.settings
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getSetting
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(GlobalMenu);



// WEBPACK FOOTER //
// ./src/components/menuItems/GlobalMenu.js